import axios from 'axios'
import { backendUrl } from '@/utils/runtime'
import type { AuthContextType } from '@/context/AuthContext'
import { Sentry } from '@/config/sentry'

const instance = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
})

let authContext: AuthContextType | undefined

instance.interceptors.response.use(
  async res => {
    const authorization = res.headers['authorization']
    if (authorization) {
      axios.defaults.headers.Authorization = `${authorization}`
      authContext?.actions?.reloadMe()
    }

    const location = res.headers['location']
    if (location) {
      window.location.replace(location)
    }

    return res
  },
  error => {
    const status = error.response?.status

    // Capture server errors (5xx) to Sentry
    if (status >= 500) {
      Sentry.captureException(error, {
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status,
          responseData: error.response?.data,
        },
      })
    }

    return Promise.reject(error)
  },
)

export const injectAuthContext = (context: AuthContextType) => {
  authContext = context
}

export default instance
